
import { createRouter, createMemoryHistory, useRoute } from 'vue-router';


const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../pages/home.vue')
    },
    {
        path: '/introduce',
        name: 'introduce',
        component: () => import('../pages/introduce.vue')
    },
    {
        path: '/activity',
        name: 'activity',
        component: () => import('../pages/activity.vue')
    },
    {
        path: '/news',
        name: 'news',
        component: () => import('../pages/news.vue')
    },
    {
        path: '/newsDetail',
        name: 'newsDetail',
        component: () => import('../pages/newsDetail.vue')
    }
]
const router = createRouter({
    history: createMemoryHistory(),
    scrollBehavior: (to) => {
        let top = 0;
        if(to.fullPath === '/newsDetail') {
            localStorage.setItem('newsDetailTop', document.documentElement.scrollTop);
        }else if(to.fullPath === '/news') {
            top = localStorage.getItem('newsDetailTop');
            localStorage.setItem('newsDetailTop', 0);
        }
        return {left: 0, top}
    },
    isAddDynamicMenuRoutes: true, // 是否添加动态菜单路由
    routes
})

export default router;